"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUBSCRIBE_OPTION_RADIO = exports.SUBSCRIBE_OPTION = exports.PURCHASE_OPTION_RADIO = exports.PURCHASE_OPTION = exports.CASHBACK = void 0;
const CASHBACK = exports.CASHBACK = 'cashback';
const PURCHASE_OPTION = exports.PURCHASE_OPTION = 'purchase-option';
const PURCHASE_OPTION_RADIO = exports.PURCHASE_OPTION_RADIO = 'purchase-option-radio';
const SUBSCRIBE_OPTION = exports.SUBSCRIBE_OPTION = 'subscribe-option';
const SUBSCRIBE_OPTION_RADIO = exports.SUBSCRIBE_OPTION_RADIO = 'subscribe-option-radio';
//# sourceMappingURL=constants.js.map